module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom15.b198c24c.jpg";